import { baseApi } from '../../../core/baseApi';
import { unwrapApiResponse } from '../../../patterns/crud';

export type ToolType = 'google_reviews' | 'website_widget';

export interface OrganizationTool {
  id: string;
  organizationId: string;
  toolType: ToolType;
  isActive: boolean;
  externalId: string | null;
  config: Record<string, unknown>;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertToolBody {
  isActive?: boolean;
  externalId?: string | null;
  config?: Record<string, unknown>;
}

export const toolsApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getOrgTools: builder.query<OrganizationTool[], string>({
      query: (organizationId) => `organizations/${organizationId}/tools`,
      transformResponse: unwrapApiResponse<OrganizationTool[]>,
      providesTags: (_result, _error, orgId) => [
        { type: 'OrgTools', id: orgId },
      ],
    }),

    getOrgTool: builder.query<OrganizationTool | null, { organizationId: string; toolType: ToolType }>({
      query: ({ organizationId, toolType }) =>
        `organizations/${organizationId}/tools/${toolType}`,
      transformResponse: unwrapApiResponse<OrganizationTool | null>,
      providesTags: (_result, _error, { organizationId, toolType }) => [
        { type: 'OrgTools', id: `${organizationId}-${toolType}` },
      ],
    }),

    upsertOrgTool: builder.mutation<OrganizationTool, { organizationId: string; toolType: ToolType; data: UpsertToolBody }>({
      query: ({ organizationId, toolType, data }) => ({
        url: `organizations/${organizationId}/tools/${toolType}`,
        method: 'PUT',
        body: data,
      }),
      transformResponse: unwrapApiResponse<OrganizationTool>,
      invalidatesTags: (_result, _error, { organizationId, toolType }) => [
        { type: 'OrgTools', id: organizationId },
        { type: 'OrgTools', id: `${organizationId}-${toolType}` },
      ],
    }),
  }),
});

export const {
  useGetOrgToolsQuery,
  useGetOrgToolQuery,
  useUpsertOrgToolMutation,
} = toolsApi;
